import { ReactNode } from "react";
import MenuBar from "../components/MenuBar";

import { useDispatch } from "react-redux";
import ListAppComp from "../components/ListApp.tsx";
import { changeVisibleListApp } from "../store/reducers/appCommonSlice";

export default function PageLayout({ children }: { children: ReactNode })
{
  const dispatch = useDispatch();


  return (
    <div className=" w-[100vw] h-[100vh] top-0 left-0  fixed div-layout">
      <div className="flex content">
        <ListAppComp />

        <div className="flex-none w-fit ">
          <MenuBar />
        </div>

        <div
          className="grow relative  bg-[var(--color-bg-content)]"
          onClick={() => dispatch(changeVisibleListApp(false))}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
